var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{staticClass:"empty",attrs:{"image":"error","description":"404-资源不存在"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }